import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;

  button + button {
    margin-left: 24px;
  }
`;
